import * as React from "react";

import { useVirtualizer } from "@tanstack/react-virtual";

import { VIRTUAL_LIST_CLASSES } from "./constants";
import { VirtualListContainer } from "./styled";
import type { VirtualListProps } from "./types";

export const VirtualList = (props: VirtualListProps): React.ReactElement => {
  const { items, estimateSize, getKey, renderItem } = props;
  const parentRef = React.useRef<HTMLDivElement>(null);

  const rowVirtualizer = useVirtualizer({
    count: items.length,
    getScrollElement: () => parentRef?.current ?? null,
    estimateSize,
  });

  return (
    <VirtualListContainer ref={parentRef}>
      <div
        style={{ height: rowVirtualizer.getTotalSize() }}
        className={VIRTUAL_LIST_CLASSES.virtualListContainer}
      >
        {rowVirtualizer.getVirtualItems().map((virtualRow) => {
          const index = virtualRow.index;
          const data = items[virtualRow.index];
          const key = getKey ? getKey(data, index) : index;

          return (
            <div
              ref={(ref) => {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (virtualRow as unknown as any)?.measureElement?.(ref);
              }}
              key={key}
              className={VIRTUAL_LIST_CLASSES.virtaulListItem}
              style={{
                transform: `translateY(${virtualRow.start}px)`,
              }}
            >
              {renderItem(data)}
            </div>
          );
        })}
      </div>
    </VirtualListContainer>
  );
};
